module.exports = __webpack_public_path__ + "static/media/Jay Desor.83d29d3f.jpg";